import { createUrlPath } from './utils';

export const sortNameAsc = (a, b) => {
  const nameA = a.systemName.toUpperCase();
  const nameB = b.systemName.toUpperCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

export const sortCategoriesByTierOrName = (categories) => {
  if (!categories) {
    return [];
  }

  return categories.sort((a, b) => {
    const aName = a.categoryName;
    const bName = b.categoryName;

    return b.tier - a.tier || aName.localeCompare(bName);
  });
};

// TODO: Move to lang
export const convertLanguageToShort = (language) => {
  switch (language) {
    case 'SWEDISH':
      return 'SV';
    case 'DANISH':
      return 'DA';
    case 'NORWEGIAN':
      return 'NO';
    case 'FINNISH':
      return 'FI';
    case 'ENGLISH':
      return 'EN';

    default:
      return 'N/A';
  }
};

export const categoryLinksCms = (categoriesArr) =>
  categoriesArr.map((cat) => {
    const { slugi18n, categoryName, categoryDbName, alternativeNames } = cat;

    return {
      id: categoryDbName,
      url: `/${slugi18n}/`,
      name: categoryName,
      alternativeNames,
    };
  });

export const getGuideIntroSectionTexts = (textsObj, hasCategorySystemGuide) => {
  const returnTextObj = {};
  returnTextObj.over = [];
  returnTextObj.under = [];

  const {
    whatIsTitle,
    whatIsText,
    howBestTitle,
    howBestText,
    compareTitle,
    compareText,
    whyTitle,
    whyText,
    priceTitle,
    priceText,
    howBuyTitle,
    howBuyText,
    faq1Title,
    faq1Text,
    faq2Title,
    faq2Text,
    topSectionTitle,
    topSectionText,
    articleTitle,
    articleText,
    textSections,
  } = textsObj;

  // Text above systems
  if (whatIsTitle && howBestTitle) {
    returnTextObj.over.push(
      {
        title: whatIsTitle,
        text: whatIsText,
      },
      {
        title: howBestTitle,
        text: howBestText,
      }
    );
  } else if (faq1Title && faq2Title) {
    returnTextObj.over.push(
      {
        title: faq1Title,
        text: faq1Text,
      },
      {
        title: faq2Title,
        text: faq2Text,
      }
    );
  } else if (topSectionTitle) {
    returnTextObj.over.push({
      title: topSectionTitle,
      text: topSectionText,
    });
  }

  // Text below systems
  if (compareTitle || whyTitle || priceTitle || howBuyTitle) {
    if (compareTitle) {
      returnTextObj.under.push({
        // label: 'Label',
        title: compareTitle,
        text: compareText,
      });
    }
    if (whyTitle) {
      returnTextObj.under.push({
        title: whyTitle,
        text: whyText,
      });
    }
    if (priceTitle) {
      returnTextObj.under.push({
        title: priceTitle,
        text: priceText,
      });
    }
    if (howBuyTitle) {
      returnTextObj.under.push({
        title: howBuyTitle,
        text: howBuyText,
      });
    }
  } else if (articleTitle) {
    returnTextObj.under.push({
      title: articleTitle,
      text: articleText,
    });
  }

  textSections?.forEach((section) => {
    const { title, text } = section;

    returnTextObj.under.push({
      title,
      text,
    });
  });

  // insert one object with text to second position in the array returnTextObj.under
  if (returnTextObj.under.length > 1 && hasCategorySystemGuide) {
    returnTextObj.under.splice(1, 0, {
      title: 'SYSTEMGUIDE',
    });
  }

  const linkTextToTextUnder = returnTextObj?.under?.[0]?.title;
  const linkIdToTextUnder =
    linkTextToTextUnder &&
    linkTextToTextUnder
      .replace(/\s+/g, '-')
      .toLowerCase()
      .replaceAll('?', '')
      .replaceAll('å', 'a')
      .replaceAll('ä', 'a')
      .replaceAll('ö', 'o')
      .replaceAll('ø', 'o')
      .replaceAll('æ', 'a');

  return { texts: returnTextObj, linkTextToTextUnder, linkIdToTextUnder };
};

export const industryLinksCms = (allIndustries, mainSlug, t) =>
  allIndustries.map((node) => {
    const { dbName, slugi18n } = node;

    return {
      id: dbName,
      url: createUrlPath([mainSlug, slugi18n]),
      name: t(`branch.${dbName}`),
    };
  });

export function unEscapeHtml(safe) {
  if (!safe) {
    return '';
  }
  return safe
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}

export function getLogoAssetObject(mediaAssets) {
  if (!mediaAssets) {
    return {};
  }

  return mediaAssets.find((asset) => asset.type === 'LOGO') || {};
}

export function getBannerAssetObject(mediaAssets) {
  if (!mediaAssets) {
    return {};
  }
  return mediaAssets.find((asset) => asset.type === 'BANNER') || {};
}

function getAssetsByType(mediaAssets, type) {
  if (!mediaAssets || !Array.isArray(mediaAssets)) {
    return [];
  }

  return mediaAssets
    .filter((mediaAsset) => mediaAsset.type === type)
    .sort((a, b) => a.order - b.order);
}

export function getPitchAssets(siteDataMediaAssets) {
  const pitchAssets = getAssetsByType(siteDataMediaAssets, 'PITCH');
  return pitchAssets?.slice(0, 1);
}

function getAssetAltText(assetObject, systemName, endingTxt) {
  if (assetObject?.altText) {
    return assetObject.altText;
  }

  if (systemName) {
    return `${systemName} - ${endingTxt}`;
  }

  return '';
}

export function getLogoAltText(logoAsset, systemName) {
  return getAssetAltText(logoAsset, systemName, 'logo');
}

export function getScreenshotAltText(screenshotAsset, systemName) {
  return getAssetAltText(screenshotAsset, systemName, 'screenshot');
}

export function getVideoAltText(videoAsset, systemName) {
  return getAssetAltText(videoAsset, systemName, 'video');
}
